export const COMPONENT_NAME_MANAGE = 'Manage';
export const COMPONENT_NAME_MANAGE_SKELETON = 'ManageSkeleton';
